import immutableUpdate from "immutable-update";

const initialState = {
  catalogs: null,
};

const reducers = {
  CATALOGS_LOADED: (state, action) => {

    if (
      JSON.stringify(state.catalogs) ===
      JSON.stringify(action.payload.data.catalogs)
    ) {

      return immutableUpdate(state, {
        catalogs: state.catalogs,
      });
    } else {
      return immutableUpdate(state, {
        catalogs: action.payload.data.catalogs,
      });
    }
  },
};

const reducer = (state = initialState, action) =>
  reducers[action.type] ? reducers[action.type](state, action) : state;

export default reducer;
